import React from "react";
import "./Footer.css"

export default function Copyright() {
  return (
    <h6 id="copyright">
      Copyright © ShopNow with ❤️ by &nbsp;
      <a title="Click Here" target="_blank" rel="noopener noreferrer" href="https://amanindian.netlify.app/"> Aman Kumar.</a>
    </h6>
  );
}
